// import { Add16 } from '@carbon/icons-react';
import React from 'react';
import styled from 'styled-components';
import { Company } from 'api/models';
import { Avatar } from 'components/atoms/avatar';

export interface CpNavbarTitleProps {
  customer: Company;
  vendor: Company;
  projectName: string;
}

const CpNavbarTitleWrapper = styled.div.attrs({
  className: 'rl-cp-nav-bar-title',
})`
  color: var(--white-100);
  border-bottom: 2px solid transparent;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: var(--cp-spacing-02);
  max-width: 250px;
  .rl-cp-nav-title-sompany-name {
    margin-left: var(--cp-spacing-02);
  }
`;

// const Span = styled.span`
//   /* ellipsis */
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   max-width: 150px;

//   @media (max-width: 480px) {
//     max-width: 150px;
//   }
// `;

export const CpNavbarTitle: React.FC<CpNavbarTitleProps> = ({
  // customer,
  vendor,
  // projectName,
}) => {
  return (
    <CpNavbarTitleWrapper>
      <Avatar
        src={vendor.companyLogoUrl}
        alt={vendor.companyName}
        name={vendor.companyName}
      />
      {/* <Add16 />
      <Avatar
        src={customer.companyLogoUrl}
        alt={customer.companyName}
        name={customer.companyName}
      />
      <Span className="rl-cp-nav-title-sompany-name">{projectName}</Span> */}
    </CpNavbarTitleWrapper>
  );
};
